// extracted by mini-css-extract-plugin
module.exports = {"icon":"SocMeLink_icon__7oMhv","icon--facebook-f":"SocMeLink_icon--facebook-f__Q_hEp"};